import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

const Wrap = styled("div")(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const Label = styled(Typography)({
  fontSize: "0.8125rem",
  fontWeight: 600,
  lineHeight: 1.4,
});

function MuiSortingView({ label, value, options = [], onChange }) {
  return (
    <Wrap>
      <Label component="h3">{label}</Label>
      <TextField
        select
        size="small"
        fullWidth
        value={value || ""}
        onChange={(e) => onChange && onChange(e.target.value)}
        sx={{
          mt: 0.75,
          "& .MuiInputBase-input": { py: 0.75, fontSize: "0.8125rem" },
        }}
        SelectProps={{ MenuProps: { PaperProps: { sx: { maxHeight: 300 } } } }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value || opt.label} value={opt.value || ""}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>
    </Wrap>
  );
}

MuiSortingView.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
};

export default MuiSortingView;

const InlineWrap = styled("div")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
}));

const InlineLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  color: theme.palette.text.secondary,
  fontWeight: 500,
}));

export function MuiSortingViewInline({ label, value, options = [], onChange }) {
  return (
    <InlineWrap>
      <InlineLabel component="span">{label}:</InlineLabel>
      <TextField
        select
        size="small"
        variant="outlined"
        value={value || ""}
        onChange={(e) => onChange && onChange(e.target.value)}
        sx={{
          minWidth: 130,
          "& .MuiInputBase-input": { py: 0.375, fontSize: "0.8125rem" },
        }}
        SelectProps={{ MenuProps: { PaperProps: { sx: { maxHeight: 300 } } } }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value || opt.label} value={opt.value || ""}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>
    </InlineWrap>
  );
}

MuiSortingViewInline.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
};
